<template>
  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :value="formatDateL(date)"
        :label="label"
        prepend-icon="event"
        readonly
        v-on="on"
        class="is_datepicker"
        :rules="required ? formRules.requiredField : []"
        clearable
        @click:clear="$emit('change', '')"
      />
    </template>
    <v-date-picker
      ref="picker"
      v-model="date"
      :max="type_birthdate ? limitDateOfBirth() : max"
      :min="type_birthdate ? '' : min"
      @change="save"
      :readonly="readonly"
      first-day-of-week="1"
    />
  </v-menu>
</template>

<script>
import FormRulesMixin from "@/mixins/FormRulesMixin";
import FormatDateMixin from "@/mixins/FormatDateMixin";

export default {
  mixins: [FormRulesMixin, FormatDateMixin],
  data() {
    return {
      date: null,
      dateFormatted: null,
      menu: false
    };
  },
  watch: {
    menu(val) {
      if (this.type_birthdate) {
        val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
      }
    },
    parent_model() {
      this.parent_model != "" ? (this.date = this.formatDate(this.parent_model)) : (this.date = null);
    },
    date() {
      this.dateFormatted = this.formatDateL(this.date);
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    type_birthdate: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    parent_model: {
      type: String,
      required: false,
      default: ""
    },
    min: {
      type: String,
      required: false,
      default: ""
    },
    max: {
      type: String,
      required: false,
      default: ""
    }
  },
  created() {
    if (this.parent_model) this.date = this.formatDate(this.parent_model);
  },
  methods: {
    save() {
      this.menu = false;
      this.$emit("change", this.date);
    },

    // Date restrinctions
    limitDateOfBirth() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 18);
      return date.toISOString().substr(0, 10);
    }
  }
};
</script>
